import { ChatContactsQuery } from '@/gql/graphql'

export const getParticipant = (chat: ChatContactsQuery['chats']['items'][0]) => {
  return chat.participant1.isCurrentUser ? chat.participant2 : chat.participant1
}
